import { BrowserModule } from '@angular/platform-browser';
import { NgModule,LOCALE_ID } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCheckboxModule,}  from '@angular/material/checkbox';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ReservationComponent } from './reservation/reservation.component';
import { WizardComponent } from './wizard/wizard.component';
import { DescriptionComponent } from './description/description.component';
import { DiagnosticComponent } from './diagnostic/diagnostic.component';
import { RdvComponent } from './rdv/rdv.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    ReservationComponent,
    WizardComponent,
    DescriptionComponent,
    DiagnosticComponent,
    RdvComponent,
    ConfirmationComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MatCheckboxModule,
  ],
  providers: [{provide: LOCALE_ID, useValue: "fr-FR" }],
  bootstrap: [AppComponent],

})
export class AppModule {

}
